import { createReducer } from './reducer-factory';

const initialState = {
    pending: false,
    mealplans: [],
    user: null,
    error: null
}
const strategies = {
    FETCH_MEALPLANS_ERROR: fetchMealplansErrorTransformer,
    FETCH_MEALPLANS_PENDING: fetchMealplansPendingTransformer,
    FETCH_MEALPLANS_SUCCESS: fetchMealplansSuccessTransformer,
    ADD_MEALPLAN_SUCCESS: addMealplanSuccessTransformer,
    UPDATE_MEALPLAN_SUCCESS: updateMealplanSuccessTransformer,
    REMOVE_MEALPLAN_SUCCESS: removeMealplanSuccessTransformer,
};
const mealplansList = createReducer(initialState, strategies);

function fetchMealplansErrorTransformer(state, action) {
    return { ...state, pending: false, error: action.error};
}
function fetchMealplansPendingTransformer(state) {
    return { ...state, pending: true };
}
function fetchMealplansSuccessTransformer(state, action) {
    return { ...state, pending: false, mealplans: action.mealplans.data, user: action.id };
}
function addMealplanSuccessTransformer (state, action){
    let currentMealplans = state.mealplans;
    if(action.mealplan.user === state.user) currentMealplans.push(action.mealplan);

    return { ...state, pending: false, mealplans: currentMealplans };
}
function updateMealplanSuccessTransformer (state, action){
    let currentMealplans = state.mealplans.filter(wi=>wi._id.toString() !== action.id.toString());
    if(action.mealplan.user === state.user) currentMealplans.push({
        ...action.mealplan,
        _id: action.id.toString()
    });

    return { ...state, pending: false, mealplans: currentMealplans };
}
function removeMealplanSuccessTransformer (state, action){
    let currentMealplans = state.mealplans.filter(wi=>wi._id.toString() !== action.id.toString());
    return { ...state, pending: false, mealplans: currentMealplans };
}

export default mealplansList

export const getMealplans = state => state.mealplansList.mealplans;
export const getMealplansUser = state => state.mealplansList.user;
export const getMealplansPending = state => state.mealplansList.pending;
export const getMealplansError = state => state.mealplansList.error;

